<style>
.v-label {
  font-size: 12px !important;
}
#attachmentsRegisterModal .modal__content {
  height: calc(100% - 60px) !important;
}
</style>

<template>
  <div style="height: 85%">
    <ExportTableData
      ref="pobierz"
      :column-defs="columnDefs"
      :grid-options="gridOptions"
    ></ExportTableData>
    <v-layout>
      <v-flex xs7>
        <v-layout
          class="table--first-row"
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              class="table__btn--green"
              @click="addAttachment"
            >add_circle</v-icon>
            <p
              class="caption"
              @click="addAttachment"
            >DODAJ ZAŁĄCZNIK</p>

            <v-icon
              class="table__btn--padding"
              v-show="selectedRow && (selectedRow.object_table != null || selectedRow.object_type === 'transmission_easement' || 'variances')"
              @click="showOnMap"
            >zoom_in</v-icon>
            <p
              class="caption"
              v-show="selectedRow && (selectedRow.object_table != null || selectedRow.object_type === 'transmission_easement' || 'variances')"
              @click="showOnMap"
            >PRZYBLIŻ</p>
            <!-- <v-icon
              class="table__btn--red table__btn--padding"
              v-show="selectedRow"
              @click="removeRow"
            >delete</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="removeRow"
            >USUŃ</p> -->
          </v-flex>
          <v-spacer />
        </v-layout>
        <v-layout
          row
          wrap
        >
          <v-flex class="table__wrapper--center">
            <v-icon
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
              class="table__btn--blue"
            >cloud_download</v-icon>
            <p
              class="caption"
              @click="'pobierz' in $refs && $refs.pobierz.showExportMenu($event)"
            >POBIERZ REJESTR</p>
            <v-icon
              class="table__btn--padding"
              v-show="selectedRow"
              @click="downloadAttachment"
            >attach_file</v-icon>
            <p
              class="caption"
              v-show="selectedRow"
              @click="downloadAttachment"
            >POBIERZ ZAŁĄCZNIK</p>

          </v-flex>
          <v-spacer />
        </v-layout>
      </v-flex>
      <v-flex
        xs5
        class="table__wrapper--center table__wrapper--filter"
      >
        <v-layout
          align-right
          justify-end
        >
          <v-text-field
            type="text"
            v-model="filter"
            placeholder="Treść filtra"
            clearable
            :hint="numberFiltered + '/' + numberAll"
            persistent-hint
            filled
          >
          </v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </div>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import ExportTableData from "../../../shared/ExportTableData";
import axios from 'axios'

export default {
  name: "App",
  data: () => ({
    filter: "",
    numberAll: '0', //hint z textfielda wymaga, by wartość była typu string
    numberFiltered: '0', //hint z textfielda wymaga, by wartość była typu string
    selectedRow: undefined,
    tableTitle: "attachmentTable"
  }),
  components: {
    AgGridVue,
    ExportTableData
  },
  computed: {
    gridOptions() {
      let gridOptions = {
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        enableColResize: "true",
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        },
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        onSelectionChanged: this.onSelectionChanged,
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        rowData: this.loadData(),
        rowSelection: "single",
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    attachments() {
      return this.$store.getters.getAttachments;
    },
    layers() {
      return this.$store.getters.getLayers;
    }
  },
  beforeMount() {
    let dict = [
      {
        headerName: "ID załącznika",
        field: "id"
      },
      {
        headerName: "Nazwa",
        field: "abstract"
      },
      {
        headerName: "Nazwa tabeli",
        field: "object_table_verbose"
      },
      {
        headerName: "Tabeli",
        field: "object_table",
        hide: true
      },
      {
        headerName: "Typ załącznika",
        field: "mimetype"
      },
      {
        headerName: "Data dodania",
        field: "posted_at",
        cellRenderer: date => {
          return new Date(date.value).toLocaleString("pl-PL", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          });
        }
      },
      {
        headerName: "Dodano przez",
        field: "posted_by_name"
      },
      {
        headerName: "ID załącznika",
        field: "object_id",
        hide: true
      }
    ];
    this.columnDefs = [];
    dict.forEach(field => {
      this.columnDefs.push(field);
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    addAttachment() {
      this.show('addAttachmentsToObjects');
    },
    downloadAttachment() {
      let payload = {
        id: this.selectedRow.id,
        filename: this.selectedRow.abstract
      };
      this.$store.dispatch("downloadAttachment", payload).then(success => {
        if(!success) {
          this.$root.$emit(
            "showSnackbar",
            "red",
            "Podczas pobierania załącznika wystąpił błąd"
          );
        }
      });
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      const self = this;
      this.$store.dispatch("getAttachments").then(success => {
        if(success) {
          self.numberAll = self.attachments.data.length;
          self.numberFiltered = self.numberAll;
          self.gridOptions.api.setRowData(self.attachments.data);
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    },
    onSelectionChanged() {
      this.selectedRow = this.gridOptions.api.getSelectedRows()[0];
    },
    refreshGrid() {
      const self = this;
      this.$store.dispatch("getAttachments").then(() => {
        if(this.gridOptions.api) {
          self.gridOptions.api.setRowData(self.$store.getters.getAttachments.data);
          self.numberAll = self.gridOptions.api.getModel().rowsToDisplay.length;
          self.numberFiltered = self.numberAll;
        }
      });
    },
    removeRow() {
      const name = this.selectedRow.filename;
      this.$store.dispatch("getAttachmentsObjects", {filename: name}).then(r => {
        if(r.status === 200) {
          const objects = {}
          r.data.result.forEach(obj => {
            if(obj.object_table) {
              if(!objects.hasOwnProperty(obj.object_table)) {
                objects[obj.object_table] = {}
                objects[obj.object_table].display_name = this.layers.find(layer => layer.type === obj.object_table).full_name
                objects[obj.object_table].objectsArrayAsString = String(obj.object_id)
              }
              else {
                objects[obj.object_table].objectsArrayAsString += `, ${String(obj.object_id)}`
              }
            }
            else {
              if(!objects.hasOwnProperty(obj.object_type)) {
                objects[obj.object_type] = {}
                objects[obj.object_type].display_name = obj.object_type
                objects[obj.object_type].objectsArrayAsString = String(obj.object_id)
              }
              else {
                objects[obj.object_type].objectsArrayAsString += `, ${String(obj.object_id)}`
              }
              // obj.display_name = obj.object_type
            }

          })
          return objects
        }
        else {
          return false
        }
      }).then(res => {
        let text = ""
        if(res) {
          text = 'Załącznik przypisany jest do następujących obiektów: '
          for(let obj in res) {
            text += `${res[obj].display_name}: ${res[obj].objectsArrayAsString}, `
          }
          text = text.slice(0, -2)
          text += `. Czy na pewno chcesz go usunąć?`

        } else {
          text = "Czy na pewno chcesz usunąć ten załącznik?"
        }
        this.$emit("confDialogOpened", true);
        this.$modal.show("dialog", {
          title: "Usuwanie załącznika",
          text: text,
          buttons: [
            {
              title: "NIE",
              handler: () => {
                this.$emit("confDialogOpened", false);
                this.$modal.hide("dialog");
                return;
              }
            },
            {
              title: "TAK",
              default: true,
              handler: () => {
                this.$store.dispatch("removeAttachment", this.selectedRow.id).then(success => {
                  if(success) {
                    this.loadData();
                  } else {
                    this.$root.$emit(
                      "showSnackbar",
                      "red",
                      "Pomyślnie usunięto załącznik"
                    );
                  }
                });
                this.$emit("confDialogOpened", false);
                this.$modal.hide("dialog");
              }
            }
          ]
        });
      })
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    showOnMap() {
      const payload = {
        object_table: this.selectedRow.object_table,
        object_id: this.selectedRow.object_id,
        srid: this.$root.projection
      };

      if(this.selectedRow.object_table == 'inspections') {
        this.$store.dispatch('getHydrantInspectionCard', this.selectedRow.object_id).then(r => {
          return r
        }).then(r => {
          if(r) {
            payload.object_table = 'hydrants'
            this.$store
              .dispatch("getFeature", payload)
              .then(
                success => success && this.$root.$emit("zoomToFeature", success, {})
              );
          }
        })
      } else if(this.selectedRow.object_type === 'app_layers') {
        this.$store
          .dispatch("getAppLayersFeature", payload)
          .then(
            success => success && this.$root.$emit("zoomToFeature", success, {})
          );
      } else if(this.selectedRow.object_type === 'layers') {
        this.$store
          .dispatch("getFeature", payload)
          .then(
            success => success && this.$root.$emit("zoomToFeature", success, {})
          );
      } else if(this.selectedRow.object_type === 'layers') {
        this.$store
          .dispatch("getFeature", payload)
          .then(
            success => success && this.$root.$emit("zoomToFeature", success, {})
          );
      } else if(this.selectedRow.object_type === "investments") {
        this.$store
          .dispatch("getSingleInvestment", this.selectedRow.object_id)
          .then(
            success => success && this.$root.$emit("zoomToFeature", success.geometry, {})
          );
      } else {
        const url = `${this.$store.getters.getApiURL}/${this.selectedRow.object_type.replace('_', '-')}/${this.selectedRow.object_id}?token=${this.$store.getters.getToken}&with_geometry=true`
        return axios.get(url).then(r => {
          if(r.status === 200) {
            if(this.selectedRow.object_type === 'transmission_easement') {
              this.$root.$emit("zoomToFeature", r.data.transmission_easement.geometry, {})
            } else if(this.selectedRow.object_type === 'video') {
              this.$root.$emit("zoomToFeature", r.data.geom, {})
            } else {
              this.$root.$emit("zoomToFeature", r.data.geometry, {})
            }
          }
        })
      }
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("addedAttachmentsGlobal", this.refreshGrid);
    this.$root.$on("deletedAttachmentGlobal", this.refreshGrid);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/attachments/AttachmentsTable.vue